var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRotate = function SvgRotate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5357 2.41382H15.8691V5.32883C14.4749 3.57816 12.3361 2.50011 10 2.50011C5.85786 2.50011 2.5 5.85798 2.5 10.0001C2.5 14.1422 5.85786 17.5001 10 17.5001C14.1421 17.5001 17.5 14.1422 17.5 10.0001H15.8333C15.8333 13.2218 13.2217 15.8334 10 15.8334C6.77834 15.8334 4.16667 13.2218 4.16667 10.0001C4.16667 6.77845 6.77834 4.16678 10 4.16678C11.9103 4.16678 13.6509 5.09334 14.7274 6.58048L11.7024 6.58048V8.24715L16.7024 8.24715C17.1626 8.24715 17.5357 7.87406 17.5357 7.41382V2.41382Z",
    fill: "white"
  }))));
};
export { SvgRotate as ReactComponent };
export default __webpack_public_path__ + "assets/b0e12d57.svg";